export default __webpack_public_path__ + "static/CookieRunBold.subset.5-255d302de5d05caa30f78346b638258b.woff";